import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Cost Centre Details")
], -1);
const _hoisted_5 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_6 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" }, "Active", -1);
const _hoisted_8 = { class: "mt-4" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Sector Active Status", -1);
const _hoisted_10 = { class: "mr-2 flex flex-row align-center" };
const _hoisted_11 = ["id", "value", "name", "checked"];
const _hoisted_12 = ["for"];
const _hoisted_13 = {
    for: "first-name",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
};
const _hoisted_14 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_15 = ["id", "onUpdate:modelValue", "type", "name", "disabled", "onBlur"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "text-red-600" };
const _hoisted_18 = { class: "pt-5" };
const _hoisted_19 = { class: "flex justify-end" };
const _hoisted_20 = ["disabled"];
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { inject, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CostCentreForm',
    props: {
        entityId: {},
        selectedCC: {}
    },
    emits: ["cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const formatDate = inject('formatDate');
        const formData = reactive({
            LKStatus: true,
            CostCentre: '',
            CostCentreName: '',
            CostCodeLookUp: '',
            EmployingEntity: '',
            SAPEmployeeGroup: '',
            EmployeeGroup: '',
        });
        const fields = [
            {
                key: 'CostCentre',
                label: 'Cost Centre',
                type: 'text',
                name: 'CostCentre-field',
                id: 'CostCentre-field',
            },
            {
                key: 'CostCentreName',
                label: 'Cost Centre Name',
                type: 'text',
                name: 'CostCentreName-field',
                id: 'CostCentreName-field',
            },
            {
                key: 'CostCodeLookUp',
                label: 'Cost Code look up',
                type: 'text',
                name: 'CostCodeLookUp-field',
                id: 'CostCodeLookUp-field',
            },
            {
                key: 'EmployingEntity',
                label: 'Employing Entity',
                type: 'text',
                name: 'EmployingEntity-field',
                id: 'EmployingEntity-field',
            },
            {
                key: 'SAPEmployeeGroup',
                label: 'SAP Employee Group',
                type: 'text',
                name: 'SAPEmployeeGroup-field',
                id: 'SAPEmployeeGroup-field',
            },
            {
                key: 'EmployeeGroup',
                label: 'Employee Group',
                type: 'text',
                name: 'EmployeeGroup-field',
                id: 'EmployeeGroup-field',
            },
        ];
        const rules = {
            formData: {
                LKStatus: { required },
                CostCentre: { required },
                CostCentreName: { required },
                CostCodeLookUp: { required },
                EmployingEntity: { required },
                SAPEmployeeGroup: { required },
                EmployeeGroup: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const handleCreateCC = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const modified = formatDate
                    ? formatDate(Date.now(), 'DD/MM/YYYY HH:mm')
                    : new Date().toISOString();
                const payload = {
                    type: 'costCentre',
                    entityId: props.entityId,
                    Modified: modified,
                    ...formData,
                };
                const response = await httpClient.post('/config/create', payload);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: props.selectedCC
                        ? 'Changes saved'
                        : 'Successfully created new cost centre',
                });
                emit('cancel', { refresh: true });
            }
            catch (err) {
                console.log(err);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: props.selectedCC
                        ? 'Error saving changes'
                        : 'Could not create cost centre',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            if (props.selectedCC) {
                Object.assign(formData, props.selectedCC);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("fieldset", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_10, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (item) => {
                                            return _createElementVNode("div", {
                                                key: item,
                                                class: "flex items-center mr-6"
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    id: `LKStatus-${item.toString()}`,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.LKStatus) = $event)),
                                                    value: item,
                                                    name: `LKStatus-${item.toString()}`,
                                                    type: "radio",
                                                    checked: formData.LKStatus === item,
                                                    class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                }, null, 8, _hoisted_11), [
                                                    [_vModelRadio, formData.LKStatus]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    for: `LKStatus-${item.toString()}`,
                                                    class: "ml-3 block text-sm font-medium text-gray-700"
                                                }, _toDisplayString(item.toString()), 9, _hoisted_12)
                                            ]);
                                        }), 64))
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
                                return _createElementVNode("div", {
                                    key: field.id,
                                    class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
                                }, [
                                    _createElementVNode("label", _hoisted_13, _toDisplayString(field.label), 1),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: field.id,
                                            "onUpdate:modelValue": ($event) => ((formData[field.key]) = $event),
                                            type: field.type,
                                            name: field.name,
                                            class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            disabled: _ctx.selectedCC,
                                            onBlur: ($event) => (_unref(v$).formData[field.key].$touch())
                                        }, null, 40, _hoisted_15), [
                                            [_vModelDynamic, formData[field.key]]
                                        ]),
                                        _createTextVNode(),
                                        (_unref(v$).formData[field.key]?.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("p", _hoisted_17, "* " + _toDisplayString(_unref(v$).formData[field.key].$errors[0].$message), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]);
                            }), 64))
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                            onClick: _cache[1] || (_cache[1] = ($event) => (emit('cancel')))
                        }, "Cancel"),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            disabled: _unref(v$).$invalid,
                            type: "submit",
                            class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            onClick: _withModifiers(handleCreateCC, ["prevent"])
                        }, "Save", 8, _hoisted_20)
                    ])
                ])
            ]));
        };
    }
});
